import React from 'react';
import BaseChoices from './BaseChoices.js';

class BooleanChoices extends BaseChoices {

    render() {
        return (
            <div id="choices-row" className="row">
                <div className="choice col-sm-6 col-md-6" onClick={() => {this.handleClick(0);}}>
                    <div className="boolean-choice">True</div>
                </div>
                <div className="choice col-sm-6 col-md-6" onClick={() => {this.handleClick(1);}}>
                    <div className="boolean-choice">False</div>
                </div>
            </div>
        );
    }
}

export default BooleanChoices;
